import { initUi } from './ui.js';
import { initTheme } from './theme.js';
import { initGenerator } from './generate.js';
import { initEditor } from './editor.js';
import { initAudio } from './audio.js';
import { initPlayer, initQuiz } from './learn.js';
import { initPlane } from './plane.js';

document.documentElement.classList.add('js');

const start = () => {
  initTheme();
  initUi();
  initGenerator();
  initEditor();
  initAudio();
  initPlayer();
  initQuiz();
  initPlane();
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', start);
} else {
  start();
}
